var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userPlayer && _vm.isTechnologyEnabled && _vm.isTechnologyResearchable)?_c('span',{on:{"click":_vm.onViewResearchRequested}},[_c('i',{class:_vm.getIcon()}),_vm._v(" "+_vm._s(_vm.researchProgress)+"%\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }